import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  withStyles,
  Avatar,
  ListItem,
  ListItemText,
  Icon,
  Typography,
} from '@material-ui/core';
import { getUser } from '../../../utils/userHelper';
import Chip from '../Chip';
import PingumIcon from '../../../images/icon-with-padding.png';
import styles from './styles';

export const UserComponent = ({
  user,
  tenantUsers,
  secondary,
  mini,
  classes,
  chip,
  bordered,
  disableGutters,
  showDelete,
  onDelete,
  onClick,
  variant,
  userAction,
}) => {
  const tenantUser = getUser(user, tenantUsers);

  const {
    userFullName = 'Pingum User',
    avatar = PingumIcon,
  } = tenantUser;

  const miniAvatar = (
    <Avatar
      src={avatar}
      className={[
        classes.miniAvatar,
        bordered
          ? classes.bordered
          : '',
      ].join(' ')}
      classes={{ img: classes.miniImg }}
    />
  );

  if (mini) {
    return miniAvatar;
  }

  if (chip) {
    return (
      <Chip
        avatar={miniAvatar}
        label={<Typography style={{ whiteSpace: 'normal' }}>{userFullName}</Typography>}
        disableGutters={disableGutters}
        showDelete={showDelete}
        onDelete={onDelete}
        onClick={onClick}
        variant={variant}
      />
    );
  }

  return (
    <div>
      <ListItem disableGutters classes={{ root: classes.listItem }}>
        {
          !!avatar
            && <Avatar src={avatar} className={classes.avatar} />
        }
        {
          !avatar
            && (
              <Avatar className={classes.avatar}>
                <Icon>account_circle</Icon>
              </Avatar>
            )
        }
        <ListItemText
          primary={(
            <span>
              <strong>{tenantUser.userFullName}</strong>
              {userAction}
            </span>
          )}
          secondary={secondary}
          classes={{
            primary: classes.primary,
            secondary: classes.secondary,
            root: classes.root,
          }}
        />
      </ListItem>
    </div>
  );
};

UserComponent.propTypes = {
  user: PropTypes.object,
  tenantUsers: PropTypes.array,
  secondary: PropTypes.string,
  classes: PropTypes.object,
  mini: PropTypes.bool,
  chip: PropTypes.bool,
  bordered: PropTypes.bool,
  disableGutters: PropTypes.bool,
  showDelete: PropTypes.bool,
  onDelete: PropTypes.func,
  onClick: PropTypes.func,
  variant: PropTypes.string,
  userAction: PropTypes.any,
};

UserComponent.defaultProps = {
  user: {},
  tenantUsers: [],
  secondary: '',
  classes: {},
  mini: false,
  chip: false,
  bordered: false,
  disableGutters: false,
  showDelete: false,
  onDelete: () => {},
  onClick: () => {},
  variant: 'default',
  userAction: '',
};

export const mapStateToProps = (state) => ({
  statuses: state.status.statuses,
  tenantUsers: state.tenant.tenantUsers,
});

export default withStyles(styles)(connect(
  mapStateToProps,
  null,
)(UserComponent));
